/**
 * Creates a GitHub issue URL with pre-filled error mapping details
 */
export const createErrorMappingIssueUrl = (params: {
  carrier: string
  errorType: string
  requestId: string
  externalId: string
  errors: any[]
  service: string
}): string => {
  const service = params.service
  const title = `[${service}]${params.carrier ? ` [${params.carrier}]` : ''} Update error map`
  const body = `**Carrier:** ${params.carrier}
**Error Type:** ${params.errorType}
**Request ID:** [${params.requestId}](${window.location.protocol}//${window.location.host}${window.location.pathname}?requestId=${params.requestId})
**External ID:** ${params.externalId}

**Errors:**
\`\`\`json
${JSON.stringify(params.errors, null, 2)}
\`\`\`

**Description:**
Please provide details about the error mapping that needs to be fixed.`

  return `https://github.com/freightview/freightview/issues/new?title=${encodeURIComponent(title)}&body=${encodeURIComponent(body)}&labels=engine`
}
